/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Injectable } from '@angular/core';
import { ApiEntity } from 'app/api/models/api-entity.model';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { ConfirmationDialogService } from 'app/shared/services/confirmation-dialog.service';
import { ListServiceBase } from 'app/shared/services/list-base.service';

import { ETicketDesignFormModel } from 'app/modules/design/e-ticket-design/e-ticket-design-management/models/e-ticket-design-form.model';
import { eTicketDesignItemViewModel } from 'app/modules/design/e-ticket-design/e-ticket-design-management/models/e-ticket-design-item-view.model';
import { eTicketDesignItemModel } from 'app/modules/design/e-ticket-design/e-ticket-design-management/models/e-ticket-design-item.model';

@Injectable({ providedIn: 'root' })
export class eTicketDesignService extends ListServiceBase {
	constructor(protected dependencies: ApiDependenciesService, protected confirmationDialogService: ConfirmationDialogService) {
		super(dependencies, confirmationDialogService);
		this.uiStateKey = 'e-ticket-design-list';
		this.initialiseFiltersSortAndPaging();
	}

	// populate initial filter properties
	private initialiseFiltersSortAndPaging() {
		// Add intialisation here
	}

	get baseEndpoint(): string {
		return '/eticket-designs';
	}
	baseEndpointWithId(id: number): string {
		return this.baseEndpoint + '/' + id;
	}

	// a number of endpoint getters are defined in ListServiceBase
	// not all endpoints will be required for all implementations

	// OVERRIDDEN from ListServiceBase
	protected getDeleteEndpoint(itemId: number): string {
		return this.baseEndpointWithId(itemId);
	}
	// OVERRIDDEN from ListServiceBase
	protected getCommandStubEndpoint(itemId: number): string {
		return this.baseEndpointWithId(itemId);
	} // OVERRIDDEN from ListServiceBase
	protected getListEndpoint(): string {
		return this.baseEndpoint + '/list';
	}

	// OVERRIDDEN from ListServiceBase
	// Create a new ViewModel specific to this list
	// Not necessary to set the viewmodel itemId as it is set in the viewModel constructor
	createListViewModel(dataModel: ApiEntity) {
		return new eTicketDesignItemViewModel(dataModel as eTicketDesignItemModel);
	}

	// OVERRIDDEN from ListServiceBase
	// Map to data model from the API response item for each list row item
	// There is an assumption here that the response item directly maps to the angular model and so can just be assigned
	getMappedListItemDataModel(responseItem: any): ApiEntity {
		const model: eTicketDesignItemModel = responseItem;
		return model;
	}

	// OVERRIDDEN from ListServiceBase
	// Map to data model from the API response item for the detail item (create/update)
	// The model must be derived from ApiEntity
	// There is an assumption here that the response item directly maps to the angular model and so can just be assigned
	getMappedEditableItemDataModel(response: any): ApiEntity {
		const model: ETicketDesignFormModel = response;
		return model;
	}

	protected getCreateEndpoint(): string {
		return this.baseEndpoint;
	}

	protected getUpdateEndpoint(itemId: number): string {
		return this.baseEndpointWithId(itemId);
	}

	// OVERRIDDEN from ListServiceBase
	protected getGetEditableItemEndpoint(itemId: number) {
		return itemId && itemId > 0 ? this.baseEndpointWithId(itemId) : this.baseEndpoint + '/blank';
	}
	// Call base method to proces the command
	// Make sure that the getCommandStubEndpoint has been overridden
	async activateToggle(itemId: number) {
		await this.sendCommand(itemId, 'activate-toggle');
	}
}
